"use client";

import { formatDate } from "@shared/utils";
import { Alert, AlertDescription } from "@ubud-ui/react-ui-kit";
import { Vacancy } from "../types";

export function VacancyExpiringAlert({ vacancy }: { vacancy: Vacancy }) {
  const expiredThreshold: number = 10;

  const isExpiring = (expiresAt: Date) => {
    const warningDate = new Date(expiresAt);
    warningDate.setDate(warningDate.getDate() - expiredThreshold);

    const now = new Date();

    return now.getTime() > warningDate.getTime();
  };

  if (!isExpiring(new Date(vacancy.expiresAt || vacancy.job?.expireAt))) {
    return <></>;
  }

  return (
    <div className="mb-6">
      <Alert variant="default" className="bg-warning-50 border-warning-200 text-warning-700">
        <AlertDescription>
          Lowongan akan segera ditutup, segera melamar sebelum tanggal{" "}
          <strong>{formatDate(vacancy.expiresAt || vacancy.job?.expireAt)}</strong>
        </AlertDescription>
      </Alert>
    </div>
  );
}
